import React, { useState } from "react";
import "./ArticleBlocks.css";
import NatureScienceModal from "./NatureScienceModal";
import RestorationModal from "./RestorationModal";
import HerbalScienceModal from "./HerbalScienceModal";
import FoodMixesModal from "./FoodMixesModal";
import HerbalInfusionsModal from "./HerbalInfusionsModal";
import FoodProductsScienceModal from "./FoodProductsScienceModal";
import tile5 from "../assets/tile5.png";
import tile6 from "../assets/tile6.png";

const articles = [
  {
    id: 1,
    title: '"WE ARE MADE OF WHAT WE EAT"',
    description: "Food supplies the essential nutrients that build, regulate, and sustain the human body, influencing health through cellular structure, signaling, and metabolic function.",
    image: "https://storage.googleapis.com/rasai-nutrie-assets/tiles/tile-1.jpg",
    bgColor: "#ffffff",
    imagePosition: "left center",
    buttonText: "Explore More",
    fullWidthImage: true,
  },
  {
    id: 2,
    title: "THE MODERN HEALTH AND NUTRITION GAP",
    description: "Despite advances in healthcare and food production, modern lifestyles and food patterns often fail to meet the body's full physiological and nutritional requirements.",
    image: "https://storage.googleapis.com/rasai-nutrie-assets/tiles/tile-2.png",
    bgColor: "#ffffff",
    imagePosition: "right center",
  },
  {
    id: 3,
    title: "THE MISSING LINK: REAL FOOD",
    description: "Diverse whole foods provide essential nutrients and bioactive compounds that support physiological balance and long-term health.",
    image: "https://storage.googleapis.com/rasai-nutrie-assets/tiles/tile-3.png",
    bgColor: "#ffffff",
    imagePosition: "left top",
  },
  {
    id: 4,
    title: "WHERE NATURE MEETS SCIENCE",
    description: "At Rasai Nutrie, our R&D team carefully bridges traditional plant wisdom with contemporary science, ensuring every formulation delivers safe, effective, and purposeful nutrition.",
    image: "https://storage.googleapis.com/rasai-nutrie-assets/tiles/tile-4.png",
    bgColor: "#ffffff",
    imagePosition: "right center",
  },
  {
    id: 5,
    title: "HERBAL INFUSIONS THROUGH THE LENS OF SCIENCE",
    description: "For centuries, cultures across the world have turned to tisanes — herbal infusions of flowers, roots, seeds, and spices — not just for comfort, but for restoration.",
    image: tile5,
    bgColor: "#ffffff",
    imagePosition: "center center",
    buttonText: "Explore More",
  },
  {
    id: 6,
    title: "SCIENCE BEHIND OUR FOOD PRODUCTS",
    description: "Our food products are developed through a science-guided approach that combines nutritional research, traditional food knowledge, and an understanding of human physiology.",
    image: tile6,
    bgColor: "#ffffff",
    imagePosition: "center center",
    buttonText: "Explore More",
  }
];

const ArticleRow = ({ article, index, onExploreClick }) => {
  const isReversed = index % 2 !== 0;

  return (
    <div
      className={`article-row ${isReversed ? "reverse" : ""} ${article.fullWidthImage ? "full-width-image" : ""}`}
      key={article.id}
    >
      <div className="article-image">
        <img src={article.image} alt={article.title} style={article.imagePosition ? { objectPosition: article.imagePosition } : {}} />
      </div>
      <div
        className="article-text"
        style={{ backgroundColor: article.fullWidthImage ? "transparent" : article.bgColor, color: "#1a1a1a" }}
      >
        <div className="article-content">
          <h2>{article.title}</h2>
          <p>{article.description}</p>
          <button onClick={() => onExploreClick(article.id)}>{article.buttonText || "Explore"}</button>
        </div>
      </div>
    </div>
  );
};

const ArticleBlocks = () => {
  const [isNatureScienceModalOpen, setIsNatureScienceModalOpen] = useState(false);
  const [isRestorationModalOpen, setIsRestorationModalOpen] = useState(false);
  const [isHerbalScienceModalOpen, setIsHerbalScienceModalOpen] = useState(false);
  const [isFoodMixesModalOpen, setIsFoodMixesModalOpen] = useState(false);
  const [isHerbalInfusionsModalOpen, setIsHerbalInfusionsModalOpen] = useState(false);
  const [isFoodProductsScienceModalOpen, setIsFoodProductsScienceModalOpen] = useState(false);

  const handleExploreClick = (articleId) => {
    if (articleId === 1) {
      setIsNatureScienceModalOpen(true);
    } else if (articleId === 2) {
      setIsRestorationModalOpen(true);
    } else if (articleId === 3) {
      setIsHerbalScienceModalOpen(true);
    } else if (articleId === 4) {
      setIsFoodMixesModalOpen(true);
    } else if (articleId === 5) {
      setIsHerbalInfusionsModalOpen(true);
    } else if (articleId === 6) {
      setIsFoodProductsScienceModalOpen(true);
    }
  };

  return (
    <>
      <section className="article-blocks">
        {articles.map((article, index) => (
          <ArticleRow
            key={article.id}
            article={article}
            index={index}
            onExploreClick={handleExploreClick}
          />
        ))}
      </section>

      <NatureScienceModal
        isOpen={isNatureScienceModalOpen}
        onClose={() => setIsNatureScienceModalOpen(false)}
      />

      <RestorationModal
        isOpen={isRestorationModalOpen}
        onClose={() => setIsRestorationModalOpen(false)}
      />

      <HerbalScienceModal
        isOpen={isHerbalScienceModalOpen}
        onClose={() => setIsHerbalScienceModalOpen(false)}
      />

      <FoodMixesModal
        isOpen={isFoodMixesModalOpen}
        onClose={() => setIsFoodMixesModalOpen(false)}
      />

      <HerbalInfusionsModal
        isOpen={isHerbalInfusionsModalOpen}
        onClose={() => setIsHerbalInfusionsModalOpen(false)}
      />

      <FoodProductsScienceModal
        isOpen={isFoodProductsScienceModalOpen}
        onClose={() => setIsFoodProductsScienceModalOpen(false)}
      />
    </>
  );
};

export default ArticleBlocks;
